import React, { useMemo } from "react";
import { Paper, Typography, Box } from "@mui/material";
import Plot from "react-plotly.js";
import { chartConfigs } from "../../utils/chartConfigs";
import { useResponsive } from "../../utils/responsive";
import { MapSkeleton } from "../common/Skeletons";
import ErrorState from "../common/ErrorState";
import useDashboardData from "../../hooks/useDashboardData";

const StateChoroplethMap = () => {
  const { data, loading, error, refetch } = useDashboardData('records/aggregate', { groupBy: 'state' });
  const { isMobile, isTablet } = useResponsive();

  // Memoize map data preparation
  const mapData = useMemo(() => {
    if (!data || data.length === 0) return { locations: [], counts: [], texts: [] };
    
    return {
      locations: data.map(d => d.state),
      counts: data.map(d => d.count),
      texts: data.map(d => `${d.state}: ${d.count} cases`)
    };
  }, [data]);

  return (
    <Paper sx={{ p: 3, height: "100%" }}>
      <Typography variant="h6" gutterBottom>
        Misconduct Cases by State
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Geographic distribution of reported misconduct cases.
      </Typography>
      <Box sx={{ minHeight: isMobile ? 350 : 500 }}>
        {loading ? (
          <MapSkeleton />
        ) : error ? (
          <ErrorState height={isMobile ? 350 : 500} message={error} onRetry={refetch} />
        ) : data.length === 0 ? (
          <ErrorState height={isMobile ? 350 : 500} message="No data available." severity="info" />
        ) : (
          <Plot
            data={[
              {
                ...chartConfigs.choropleth.trace,
                locations: mapData.locations,
                z: mapData.counts,
                text: mapData.texts,
                hovertemplate: '<b>%{text}</b><extra></extra>'
              }
            ]}
            layout={{
              ...chartConfigs.choropleth.layout,
              width: isMobile ? 350 : isTablet ? 650 : 900,
              height: isMobile ? 350 : 500,
              margin: isMobile 
                ? { t: 20, l: 20, r: 20, b: 20 }
                : { t: 30, l: 30, r: 30, b: 30 }
            }}
            config={{ 
              responsive: true,
              displayModeBar: !isMobile
            }}
          />
        )}
      </Box>
    </Paper>
  );
};

export default StateChoroplethMap;